import React, { Suspense, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Afosto } from '@afosto/icons/social';
import { App as BaseApp, SplashScreen } from '@afosto/shared-components';
import { APP_SCOPES, CLIENT_ID } from '../constants';
import translations from './translations';

const isRunningFromFrame = window.self !== window.top;
const LazyRoutes = !isRunningFromFrame
  ? React.lazy(() => import('./components/AppRoutes'))
  : () => <div>frame</div>;

const App = () => {
  const [hasNavigation, setHasNavigation] = useState(false);

  return (
    <BaseApp
      clientId={CLIENT_ID}
      scopes={APP_SCOPES}
      appState={{
        hasNavigation,
        setHasNavigation,
        userMenuItems: [
          {
            key: 'account',
            items: [
              {
                icon: Afosto,
                label: <FormattedMessage {...translations.afostoPlatform} />,
                href: 'https://afosto.app',
                key: 'afostoPlatform',
              },
            ],
          },
        ],
      }}
      disableNotifications
    >
      <Suspense fallback={<SplashScreen />}>
        <LazyRoutes />
      </Suspense>
    </BaseApp>
  );
};

export default App;
